import { AbstractControl, ValidationErrors } from '@angular/forms';

export function isNotConfirmedPassword(control: AbstractControl | any): ValidationErrors | null {
  if (
    !control.parent ||
    (!control.parent.controls.ConfirmPassword.touched && !control.parent.controls.Password.touched)
  ) {
    return null;
  }
  const parentForm = control.parent,
    pass = parentForm.controls.Password ? parentForm.controls.Password.value : null,
    confirmPass = parentForm.controls.ConfirmPassword ? parentForm.controls.ConfirmPassword.value : null;

  return pass === confirmPass || (!pass && !confirmPass) ? null : { isNotConfirmedPassword: true };
}
